import { takeLatest, call, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";

import history from "~/services/history";
import api from "~/services/api";

import {
  saveCcyb1Failure,
  saveCcyb1Success,
  updateCcyb1Failure,
  updateCcyb1Success
} from "./actions";

export function* saveCcyb1({ payload }) {
  try {
    yield call(api.post, "api/ccyb1", payload.data, { withCredentials: true });

    yield put(saveCcyb1Success());

    toast.success("Ccyb1 criado com sucesso!");

    history.push("/specifications/pilar3/resources/ccyb1");
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCcyb1Failure());
  }
}

export function* updateCcyb1({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/ccyb1/${id}`, payload.data, { withCredentials: true });

    yield put(updateCcyb1Success());

    toast.success("Ccyb1 atualizado com sucesso!");

    history.push("/specifications/pilar3/resources/ccyb1");
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateCcyb1Failure());
  }
}

export default all([
  takeLatest("@ccyb1/SAVE_REQUEST", saveCcyb1),
  takeLatest("@ccyb1/UPDATE_REQUEST", updateCcyb1)
]);
